'use client'
import { getWalletBookWallet, isWalletMethodSupported } from '@dynamic-labs/wallet-book';

const isConnectorMethodSupported = (connector, method, platform) => {
    const walletBookWallet = connector.constructorProps.walletData ||
        getWalletBookWallet(connector.walletBook, connector.key);
    return isWalletMethodSupported(walletBookWallet, method, platform);
};

export { isConnectorMethodSupported };
